export default __webpack_public_path__ + "1f860bc7eaac2ea71e8cc6648e0d696a.woff2";